/**
 * React Query hooks for User Files/Media Management
 */

import { useQuery } from '@tanstack/react-query'
import { filesApi } from '@api/endpoints/files'
import type { GetFilesParams } from '@api/types/files'

// ===================
// Query Keys
// ===================

export const USER_FILE_QUERY_KEYS = {
  all: ['user-files'] as const,
  list: (params?: GetFilesParams) => [...USER_FILE_QUERY_KEYS.all, 'list', params] as const,
  detail: (fileId: string) => [...USER_FILE_QUERY_KEYS.all, 'detail', fileId] as const,
}

// ===================
// Query Hooks
// ===================

/**
 * Get list of user's files with filtering and pagination
 */
export function useUserFiles(params?: GetFilesParams) {
  return useQuery({
    queryKey: USER_FILE_QUERY_KEYS.list(params),
    queryFn: () => filesApi.getFiles(params),
  })
}
